var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Caminho_19",
  "data-name": "Caminho 19",
  transform: "translate(0)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.2,0H46.809a7.2,7.2,0,0,1,7.2,7.2V46.809a7.2,7.2,0,0,1-7.2,7.2H7.2a7.2,7.2,0,0,1-7.2-7.2V7.2A7.2,7.2,0,0,1,7.2,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 7.201313018798828 2 C 4.333293914794922 2 1.999992370605469 4.333301544189453 1.999992370605469 7.201320648193359 L 1.999992370605469 46.80860137939453 C 1.999992370605469 49.67662048339844 4.333293914794922 52.00992202758789 7.201313018798828 52.00992202758789 L 46.80857467651367 52.00992202758789 C 49.67658233642578 52.00992202758789 52.00988388061523 49.67662048339844 52.00988388061523 46.80860137939453 L 52.00988388061523 7.201320648193359 C 52.00988388061523 4.333301544189453 49.67658233642578 2 46.80857467651367 2 L 7.201313018798828 2 M 7.201313018798828 0 L 46.80857467651367 0 C 50.78574371337891 0 54.00988388061523 3.224140167236328 54.00988388061523 7.201320648193359 L 54.00988388061523 46.80860137939453 C 54.00988388061523 50.78578186035156 50.78574371337891 54.00992202758789 46.80857467651367 54.00992202758789 L 7.201313018798828 54.00992202758789 C 3.224143981933594 54.00992202758789 -7.62939453125e-06 50.78578186035156 -7.62939453125e-06 46.80860137939453 L -7.62939453125e-06 7.201320648193359 C -7.62939453125e-06 3.224140167236328 3.224143981933594 0 7.201313018798828 0 Z",
  stroke: "none",
  fill: "silver"
}));
var _ref3 = /*#__PURE__*/React.createElement("line", {
  id: "Linha_42",
  "data-name": "Linha 42",
  x2: 28.805,
  transform: "translate(12.602 27.005)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 3
});
function SvgMeio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "meio",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.01,
    height: 54.01,
    viewBox: "0 0 54.01 54.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeio);
export default __webpack_public_path__ + "static/media/meio.8dbd25ab5b712afdd62a8558112999fe.svg";
export { ForwardRef as ReactComponent };